import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';

/**
 * Generates a unique email address for a new user based on their last name
 * Format: lastname123@namat.org.sa
 */
export async function generateUniqueEmail(lastName: string): Promise<string> {
  let isUnique = false;
  let email = '';
  let attempts = 0;
  const MAX_ATTEMPTS = 10;
  
  while (!isUnique && attempts < MAX_ATTEMPTS) {
    attempts++;
    
    // Generate random 3 digits
    const randomNum = Math.floor(Math.random() * 900) + 100; // 100-999
    
    // Create email with lowercase lastname and remove any spaces
    email = `${lastName.toLowerCase().replace(/\s+/g, '')}${randomNum}@namat.org.sa`;
    
    // Check if email exists
    const usersRef = collection(db, 'users');
    const q = query(usersRef, where('email', '==', email));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      isUnique = true;
    }
  }
  
  if (!isUnique) {
    throw new Error('Could not generate unique email after maximum attempts');
  }
  
  return email;
}